import request from '@/utils/request'

// 查询列表 通过编号
export function getGoodsReq(query) {
  return request({
    url: '/api/goods/getGoods',
    method: 'GET',
    params: query , //params修改为data
  })
}
//加入购物车
export function addCartItemReq(query){
  return request({
    url: '/api/cartItem/addCartItem',
    method: 'GET',
    params: query , //params修改为data
  })
}

